import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

// hooks
import { usePosthogCapture } from 'documentDisplay/posthogCapture/_index';

// assets
import { General } from 'icons/untitledui';

// components
import ConfirmDialog from 'shared/ConfirmDialog';

// style
import * as Styled from 'documentDisplay/styles/Document.style';
import * as Text from 'theme/components/Text.style';

interface DocumentShareButtonProps {
  docURL: string;
  useSourceUrl?: boolean;
  sourceUrl?: string;
}

export default function DocumentShareButton({
  docURL,
  useSourceUrl,
  sourceUrl,
}: DocumentShareButtonProps): JSX.Element {
  const { t } = useTranslation('pageDocumentDisplay');
  const documentDisplay = usePosthogCapture();

  const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);
  const handleConfirmDialogOpen = () => setIsOpenConfirmDialog(true);
  const handleConfirmDialogClose = () => setIsOpenConfirmDialog(false);

  const getBaseUrl = (): string => {
    const parsedUrl = new URL(window.location.href);
    return parsedUrl.origin;
  };

  const getConfirmDialogText = (): string =>
    t(
      'documentDisplay.DocumentShareButton.Link copied! Please note that this link will only work if the recipient has a valid Nurau account.'
    );

  const confirmDialog = (
    <ConfirmDialog
      cancelLabel={t('documentDisplay.DocumentShareButton.Close')}
      contentText={getConfirmDialogText()}
      handleClose={handleConfirmDialogClose}
      isOpen={true}
    />
  );

  const copyToClipboard = (): void => {
    documentDisplay.shared();
    let urlToCopy = `${getBaseUrl()}${docURL}`;

    if (useSourceUrl && sourceUrl) {
      urlToCopy = sourceUrl;
    }

    navigator.clipboard
      .writeText(urlToCopy)
      .then(handleConfirmDialogOpen)
      .catch((err) => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <Styled.ShareButton onClick={copyToClipboard}>
        <General.Copy03 size={15} />
        <Text.P2>{t('documentDisplay.DocumentShareButton.Share')}</Text.P2>
      </Styled.ShareButton>
      {isOpenConfirmDialog && confirmDialog}
    </>
  );
}
